import { call, put, takeLatest } from 'redux-saga/effects';
import { getParticipation } from '../../services/API';
import { actionTypes, getParticipationFailure, getParticipationSuccess } from './actions';

function* getData(action) {
  const { isOk, data, error } = yield call(getParticipation, action.payload);
  yield put(isOk ? getParticipationSuccess(data) : getParticipationFailure(error));
}

export default function* participationInOrganizationsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
